<template>
    <div class="story-maker-sticker story-maker-sticker-mention" :class="{edit : isEditing,  hide: isHide}" @click="finish">
        <!-- <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')"> -->
        <!-- <p class="text-finish" @click="finish">Terminé</p> -->
        <template v-if="isEditing">
            <i v-if="isHide" class="fa-solid fa-eye-slash" @click="toggleHide"></i>
            <i v-else class="fa-solid fa-eye" @click="toggleHide"></i>
        </template>
      
        <div class="sticker sticker-mention" 
            :class="{
                [`style${styleVariant}`]: !isFacebook,
                'facebook-mention': isFacebook,
            }"

            :style="{ 
                top: `${$attrs.position.y}%`, 
                left: `${$attrs.position.x}%`,
                transform: isCover || isPreventCover ? `translate(-50%, -50%) scale(${$attrs.transform.scale}) rotate(${$attrs.transform.rotate}deg)` : ''
            }"
        >
           <div class="icon" v-if="!isFacebook"></div>
            <p
                :contenteditable="isEditing"
                @input="handlerInput"
                ref="mentionInput"
                v-html="models.mention"
                class="textarea"
            ></p>
        </div>

        <div class="mentions hide-scrollbar" @wheel="handleHorizontalScroll">
            <div v-if="stateLoader && models.mention.length" class="mention-loader">
                <span class="loader"></span>
            </div>
            <template v-else>
                <div
                    class="mention"
                    :class="{ selected: selectedMention && selectedMention.id === m.id }"
                    v-for="m in mentions"
                    :key="m.id"
                    @click.stop="selectMention(m)"
                >
                    <div class="image">
                        <img :src="mentionImage(m)" alt="">
                         <i v-if="selectedMention && selectedMention.id === m.id" class="fa-solid fa-circle-check mention-check"></i>
                    </div>

                    <p>{{mentionLabel(m)}}</p>
                   
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import store from '@/store/index.js'
import { EventBus } from '@/event-bus';
import minxinBots from '@/components/mixins/Bots.vue'
export default {
    mixins: [minxinBots],

    props: {
        id: [Number, String],
        isEditing: Boolean,
        mention: String,
        styleVariant: Number,
        isHide: Boolean,
        isPreventCover: Boolean,
        isCover: Boolean,
        setCover: Function,
        setCbClick: Function,
        pageSelected: Object,
    },

    data() {
        return {
            models: {
                mention: ''
            },
            cursorPosition: null,
            timeoutInitSearch: null,
            stateLoader: true,
           
            mentions:[],
            selectedMention: null,
        };
    },

    mounted () {
        if (this.mention) {
            this.$set(this.models, 'mention', this.mentionLabel(this.mention));
            if (this.mention.id) {
                this.selectedMention = { id: this.mention.id, pk: this.mention.pk, name: this.mention.name };
            }
        }

        if (this.isEditing) {
            this.focusAtEnd(this.$refs[`mentionInput`]);
            if (this.mention && this.mention.id) this.searchPerson();
        }

        if (this.setCbClick) this.setCbClick(this.changeStyleVariant);
        EventBus.$on('storyMaker-confirmEditingSticker', this.saveCurrentState);
    },
    methods: {

        mentionLabel(m) {
            if (!m) return ''
            return m.pk ? m.id : (m.name || m.id)
        },

        mentionImage(m) {
            if (!m) return 'img/avatar.jpg'
            return m.image || (m.picture && m.picture.data && m.picture.data.url) || 'img/avatar.jpg'
        },

        clickSticker() {
            if (this.isEditing) return
            this.setCover(true)
            this.$nextTick(() => {
                this.$emit('updateSticker', this.id, { isEditing: true })
                this.focusAtEnd(this.$refs[`mentionInput`]);
                if (this.mention && this.mention.id) {
                    this.selectedMention = { id: this.mention.id, pk: this.mention.pk, name: this.mention.name };
                }
                if (this.mention && this.mention.id) this.searchPerson();
            })
        },
        handlerInput(e) {
            this.selectedMention = null
            this.updateCursorPosition()
            this.models.mention = e.target.innerHTML
            const noSpaces = e.target.innerHTML.replaceAll(' ', '')
            const newTextMention = noSpaces.toLowerCase()
            this.$nextTick(() => {
                if (e.target.innerHTML !== newTextMention) {
                    this.models.mention = newTextMention
                    if (e.target.innerHTML !== noSpaces) {
                        this.cursorPosition = this.cursorPosition > 0 ? this.cursorPosition - 1 : 0
                    }
                    this.$nextTick(() => {
                        this.restoreCursorPosition()
                        this.searchPerson()
                    })
                } else {
                    this.restoreCursorPosition()
                    this.searchPerson()
                }
            })

           
        },

        focusAtEnd(element) {
            if (!element || !element.isContentEditable) return;

            const range = document.createRange();
            const selection = window.getSelection();

            range.selectNodeContents(element);
            range.collapse(false);

            selection.removeAllRanges();
            selection.addRange(range);

            // Donnez le focus à l'élément
            element.focus();
        },
       
        updateCursorPosition() {
           const selection = window.getSelection();
           if (selection.rangeCount > 0) {
                const range = selection.getRangeAt(0);
                let nodeIndex = 0
                if (this.cursorPosition !== range.startOffset) {
                    this.cursorPosition = range.startOffset
                }
           }
       },
       
        restoreCursorPosition() {
            this.$refs[`mentionInput`].focus();
            let node = this.$refs[`mentionInput`].childNodes[0]
            if (!node) return
            const selection = window.getSelection();
            selection.removeAllRanges();
            const range = document.createRange();
            // the text can change between capturing cursorPosition and restoring it, leaving the
            // offset past the node's current length (FRONT-SAAS-3T)
            range.setStart(node, Math.min(this.cursorPosition, node.length || 0));
            range.collapse(true);
            selection.addRange(range);
        },

        selectMention(mention) {
            this.selectedMention = mention;
            this.$set(this.models, 'mention', this.mentionLabel(mention));
            this.$nextTick(() => { this.focusAtEnd(this.$refs['mentionInput']); });
        },

        saveCurrentState(mention = null) {
            if (!this.isEditing) return;
            if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch);
            const mentionToUse = mention || this.selectedMention;

            if (!mentionToUse || !mentionToUse.id) {
                this.$emit('deleteSticker', this.id);
                this.mentions = [];
                if (this.timeoutFinish) clearTimeout(this.timeoutFinish);
                this.timeoutFinish = setTimeout(() => { this.setCover(false); }, 200);
                return;
            }

            const idMention = mentionToUse.id.replace(/<br>/g, '').replace(/[^a-zA-Z0-9._]/g, '');
            if (!idMention) {
                this.$emit('deleteSticker', this.id);
                this.mentions = [];
                if (this.timeoutFinish) clearTimeout(this.timeoutFinish);
                this.timeoutFinish = setTimeout(() => { this.setCover(false); }, 200);
                return;
            }

            this.$set(this.models, 'mention', this.mentionLabel({ ...mentionToUse, id: idMention }));
            this.$emit('updateSticker', this.id, {
                isEditing: false,
                data: {
                    ...this.$attrs.data,
                    mention: { id: idMention, pk: mentionToUse.pk, name: mentionToUse.name }
                },
            });
            this.mentions = [];
            if (this.timeoutFinish) clearTimeout(this.timeoutFinish);
            this.timeoutFinish = setTimeout(() => { this.setCover(false); }, 200);
        },

        finish(event, mention = null) {
            console.log('finish mention')
            if (this.isCover && event.target.classList.contains('story-maker-sticker') || event.target.classList.contains('text-finish') || event.target.classList.contains('mention-event')) {
                this.saveCurrentState(mention);
            }
        },

        async searchPerson(value) {

            if (this.timeoutInitSearch) clearTimeout(this.timeoutInitSearch)
            this.stateLoader = true
            this.timeoutInitSearch = setTimeout(async () => {
                let page = this.pageSelected || this.pagesSelected.find(p => p.network == "instagram" && p.story_config && p.story_config.created)
                if (page) {
                    this.stateLoader = true
                    this.mentions = (await this.getMentionsByApi(page.id, this.$refs[`mentionInput`].innerText, false, true, true)).mentions
                    this.stateLoader = false
                    // the component can be destroyed while getMentionsByApi() is in flight
                    if (!this.$refs[`mentionInput`]) return
                    const typedUsername = this.$refs[`mentionInput`].innerText.trim().toLowerCase();
                    const exactMatch = this.mentions && this.mentions.find(m => m.id && m.id.toLowerCase() === typedUsername);
                    if (exactMatch) {
                        this.selectMention(exactMatch);
                    }
                }
            },1000)
           
        },

        changeStyleVariant(e) {
            this.$emit('updateSticker',this.id , {
                data : {
                    ...this.$attrs.data,
                    styleVariant :(this.styleVariant % 6) + 1
                },
                
            })
        },

        toggleHide(e) {
            this.$emit('updateSticker',this.id , {
                data : {
                    ...this.$attrs.data,
                    isHide : !this.isHide
                },

                disableTransform: !this.isHide,
                disableMove: !this.isHide
            })
        },

        handleHorizontalScroll(event) {
            if (event.deltaX == 0) {
                event.preventDefault();
                const scrollContainer = event.currentTarget;
                scrollContainer.scrollLeft += event.deltaY;
            }
        }

        
    },

    watch: {
        mention: {
            handler(newMention) {
                if (newMention) {
                    this.$set(this.models,'mention', this.mentionLabel(newMention))
                }
            },
            immediate: true
        },

        isEditing: {
            handler(newValue) {
                if (newValue && !this.isPreventCover && !this.isCover) {
                    this.isEditing = false
                    this.clickSticker()
                }
            },
            immediate: true
        },
    },

    beforeDestroy() {
        EventBus.$off('storyMaker-confirmEditingSticker', this.saveCurrentState);
    },

    computed: {
        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages'];
        },
        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id]);
        },
        isFacebook() {
            return !!(this.pageSelected && this.pageSelected.network === 'facebook')
        },
    },
};
</script>
